export function getNextCustomSortOrderByBooks(books = []) {
  let minOrder = Infinity;
  for (const book of books) {
    const order = book?.sortOrder;
    if (typeof order === 'number' && Number.isFinite(order) && order < minOrder) {
      minOrder = order;
    }
  }
  return minOrder === Infinity ? 0 : minOrder - 1;
}

export function toggleSortMenuByElements(menuEl, elements) {
  if (!menuEl) return;
  const otherMenu = menuEl === elements.sortMenu ? elements.booklistSortMenu : elements.sortMenu;
  otherMenu?.classList.remove('active');
  menuEl.classList.toggle('active');
}

export function handleSortByWithUi({
  sortBy,
  state,
  elements,
  renderCurrentView,
  showToast,
  documentRef = document
}) {
  state.sortBy = sortBy;

  documentRef.querySelectorAll('.sort-option').forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.sort === sortBy);
  });

  elements.sortMenu?.classList.remove('active');
  elements.booklistSortMenu?.classList.remove('active');

  if (sortBy === 'custom' && state.currentView === 'shelf') {
    showToast?.('拖拽书籍可调整顺序');
  }

  renderCurrentView?.();
}
